<div class="flex justify-between items-center max-w-8xl mx-auto py-2 px-4 sm:px-6 lg:px-8">
    <h1 class="text-lg leading-6 font-semibold text-gray-900">PPA Inventory</h1>
    <app-action-button *ngIf="hasInventoryAccess()" [items]="addItems"></app-action-button>
    <app-action-button-disabled *ngIf="!hasInventoryAccess()"></app-action-button-disabled>
</div>

